import { Stack, Typography } from "components";
import { formatAmount } from "helpers";
import { DoctorFees } from "features/doctors/DoctorFees";
import CheckoutLoader from "./CheckoutLoader";
import { AppointmentType, Discount } from "types";

type PaymentTableProps = {
  type: AppointmentType;
  total: number;
  discount: Discount;
  doctorId?: string;
};

const PaymentTable: React.FC<PaymentTableProps> = ({
  type,
  total,
  discount,
  doctorId,
}) => {
  const amountWrapperStyle: React.CSSProperties = {
    padding: "8px 16px",
    margin: "0 -16px",
    textAlign: "center",
    background: "#e3f2fd",
    color: "#F64D10"
  };

  return (
    <Stack direction="column" placeItems="stretch" gap={2}>
      <Typography>Payment</Typography>
      {doctorId ? (
        <Typography size={4} weight={500} style={amountWrapperStyle}>
          {formatAmount(total, "₱", 2)}
        </Typography>
      ) : (
        <CheckoutLoader />
      )}
      {doctorId && (
        <DoctorFees id={doctorId} type={type} discount={discount} size={-1} />
      )}
    </Stack>
  );
};

export default PaymentTable;
